<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <div class="card-body mb-0">
        <b-link class="brand-logo">
          <!-- <vuexy-logo /> -->
          <img
            style="width: 270px;"
            src="https://dkplayer.s3.sa-east-1.amazonaws.com/logo-since-2000.webp"
          >

        </b-link>

        <b-card-title class="mb-1">
          Seja Bem-vindo👋
        </b-card-title>
        <b-card-text class="mb-2">
          Area do Aluno.
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginValidation"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="validationForm"
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  placeholder="john@example.com"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Senha</label>
                <b-link @click="Password();">
                  <small>Esqueceu a senha?</small>
                </b-link>
              </div>

              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    placeholder="Password"
                  />
                  <b-input-group-append is-text>

                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              Entrar
            </b-button>
          </b-form>
        </validation-observer>

        <!--        <b-card-text class="text-center mt-2">-->
        <!--          <span>Novidade em nossa plataforma?</span>-->
        <!--          <b-link href="https://vslbooster.com/#planos">-->
        <!--            <span>&nbsp;Crie uma conta</span>-->
        <!--          </b-link>-->
        <!--        </b-card-text>-->
      </div>
      <!-- /Login v1 -->

    </div>
  </div>
</template>
<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import PassWordService from '@/services/RedefirSenha'
import Swal from 'sweetalert2'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,

  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      usuario: [],
      nome: '',
      sobrenome: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },

  methods: {

    getUsuarioEmail() {
      const options = {
        method: 'POST',
        url: `${this.VUE_APP_HOST_API_BACKEND}/usuario_email_aluno`,
        headers: { 'Content-Type': 'application/json' },
        data: { user_email: `${this.userEmail}` },
      }

      axios.request(options)
        .then(response => {
          console.log('RESPONSE', response)
          if (response.data[0].user_primeiro_acesso === 0) {
            this.loginInput()
          } else {
            this.$confirm('Olá você precisa cadastrar sua senha!', 'Aviso', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning',
              center: true,
            }).then(() => this.$router.push(`/RedefinirSenha/${response.data[0].user_email}`)).catch(() => {
              this.$message({
                type: 'info',
                message: 'Delete canceled',
              })
            })
          }
        }).catch(error => {
          this.$message({
            type: 'error',
            message: 'Email ou senha incorretos!',
          })
          console.error(error)
        })
    },
    async loginInput() {
      await this.$refs.loginValidation.validate().then(success => {
        if (success) {
          useJwt.login({
            user_email: this.userEmail,
            user_password: this.password,
          })
            .then(response => {
              const { userData } = response.data
              if (userData.user_ativo === 0) {
                Swal.fire(
                  'Usuário bloqueado!',
                  `<div style="text-align: left; flex-wrap: nowrap"><p>Favor entrar em contato com a equipe VSL Booster</p>
<p>E-mail: <strong>financeiro@vslbooster.com</strong></p></div>`,
                  'error',
                )
                return
              }
              localStorage.setItem('lgn_admin', JSON.stringify(userData.user_role))
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              this.$router.replace(getHomeRouteForLoggedInUser(userData.user_role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Bem-vindo ${userData.user_name || userData.user_sobrenome}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',

                    },
                  })
                })
            })
            .catch(error => {
              this.$message({
                type: 'error',
                message: 'Email ou senha incorretos!',
              })
              console.log('error', error)
              this.$refs.loginValidation.setErrors(error.response.error)
            })
        }
      })
    },
    async Password() {
      console.log('CHAMEI AQUI', this.userEmail)
      const options = {
        method: 'POST',

        url: `${this.VUE_APP_HOST_API_BACKEND}/usuario_email`,
        headers: { 'Content-Type': 'application/json' },
        data: { user_email: `${this.userEmail}` },
      }
      axios.request(options)
        .then(response => {
          if (typeof response.data[0] !== 'undefined') {
            PassWordService.ChangePassword(this.userEmail)
              .then(response => {
                const verifyUser = response.data.auth === true ? 'Autorizado' : 'null'
                if (verifyUser === 'Autorizado') {
                  console.log('autorizado')
                  this.$router.push({ name: 'verificarEmail' })
                }
              })
              .catch(error => {
                console.log('error', error)
              })
          } else {
            this.$message({
              type: 'error',
              message: 'Email não encontrado',
            })
          }
        }).catch(error => {
          console.error(error)
        })
      //
    },
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.getUsuarioEmail()
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
[aria-describedby="swal2-html-container"] {
  width: 459px !important;
}
</style>
